import { BaseService } from '../../infra/base.service'
import type { UserServiceComission } from './user-service-comission'
import type { UserServiceComissionsRepository } from './user-service-comissions.repository'

export class UserServiceComissionsService extends BaseService<UserServiceComission> {
    constructor(private rep: UserServiceComissionsRepository) {
        super(rep)
    }

    async getByUser(userId: string) {
        return await this.rep.getByUser(userId)
    }

    async saveByUser(userId: string, items: UserServiceComission[]) {
        return await this.rep.saveByUser(userId, items)
    }
}
